var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 515,
    height: 360,
    viewBox: "0 0 515 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.256 300.407C259.217 300.407 208.113 246.511 208.113 180.027C208.113 113.543 259.217 59.6479 322.256 59.6479C385.295 59.6479 436.398 113.543 436.398 180.027C436.398 246.511 385.295 300.407 322.256 300.407Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round",
    strokeDasharray: "12.15 12.15"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.094 350.5C232.808 350.5 160.428 274.165 160.428 180C160.428 85.8354 232.808 9.5 322.094 9.5C411.38 9.5 483.76 85.8354 483.76 180C483.76 274.165 411.38 350.5 322.094 350.5Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round",
    strokeDasharray: "12.15 12.15"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.295 205.946L201.684 204.885L187.491 218.856L182.295 205.946Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.295 205.946L201.684 204.885L187.491 218.856L182.295 205.946Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.194 218.625L147.558 209.957L160.624 242.418L141.26 251.086L128.194 218.625Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.287 202.933L149.065 200.795L167.923 247.642L163.144 249.781L144.287 202.933Z",
    fill: "#F5F5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.287 202.933L149.065 200.795L167.923 247.642L163.144 249.781L144.287 202.933Z",
    fill: "#F0F0F0",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.703 261.019L166.632 252.993L189.269 309.231L171.34 317.257L148.703 261.019Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.084 210.782L156.395 209.3L167.213 236.172L163.901 237.654L153.084 210.782Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.549 214.033L166.219 210.599L166.951 212.417L159.28 215.85L158.549 214.033Z",
    fill: "#F5F5F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.549 214.033L166.219 210.599L166.951 212.417L159.28 215.85L158.549 214.033Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.766 229.476L172.436 226.042L173.168 227.86L165.497 231.293L164.766 229.476Z",
    fill: "#F5F5F5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.766 229.476L172.436 226.042L173.168 227.86L165.497 231.293L164.766 229.476Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.393 248.924L157.65 257.014L155.927 257.786L152.67 249.695L154.393 248.924Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.793 226.858L128.195 218.625L141.262 251.087L132.587 248.708L123.793 226.858Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.792 226.858L118.387 223.016L131.453 255.477L132.587 248.708L123.792 226.858Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.621 228.931L115.103 227.756L118.998 237.435L122.03 232.432L120.621 228.931Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.561 246.173L122.042 244.997L125.938 254.676L128.97 249.673L127.561 246.173Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.321 210.981L159.626 209.949L162.781 217.786L160.476 218.818L157.321 210.981Z",
    fill: "#F0F0F0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.321 210.981L159.626 209.949L162.781 217.786L160.476 218.818L157.321 210.981Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.554 226.466L165.859 225.434L169.014 233.271L166.708 234.304L163.554 226.466Z",
    fill: "#F0F0F0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.554 226.466L165.859 225.434L169.014 233.271L166.708 234.304L163.554 226.466Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.543 246.932L153.986 245.391L155.563 249.309L152.12 250.85L150.543 246.932Z",
    fill: "#F5F5F5",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.012 218.697C165.184 204.218 166.094 189.501 172.598 182.873C173.673 181.778 176.138 179.94 178.094 184.8C180.05 189.66 197.131 232.097 198.913 236.523C200.695 240.949 198.046 242.323 196.553 242.378C187.512 242.71 176.84 233.176 171.012 218.697Z",
    fill: "#F5F5F5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.012 218.697C165.184 204.218 166.094 189.501 172.598 182.873C173.673 181.778 176.138 179.94 178.094 184.8C180.05 189.66 197.131 232.097 198.913 236.523C200.695 240.949 198.046 242.323 196.553 242.378C187.512 242.71 176.84 233.176 171.012 218.697Z",
    fill: "#F0F0F0",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.597 209.052L167.902 208.021L176.078 228.333L173.773 229.365L165.597 209.052Z",
    fill: "#F0F0F0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.597 209.052L167.902 208.021L176.078 228.333L173.773 229.365L165.597 209.052Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.438 207.236C202.046 207.859 200.439 207.174 199.848 205.706C199.258 204.238 199.907 202.543 201.298 201.92C202.69 201.298 204.297 201.983 204.888 203.45C205.479 204.918 204.83 206.613 203.438 207.236Z",
    fill: "#BFBFBF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.111 260.567L164.257 258.445L166.269 257.544L167.123 259.666L165.111 260.567Z",
    fill: "#BFBFBF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.498 264.015L165.644 261.893L167.656 260.993L168.51 263.114L166.498 264.015Z",
    fill: "#BFBFBF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.887 267.463L167.033 265.341L169.044 264.441L169.898 266.563L167.887 267.463Z",
    fill: "#BFBFBF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.275 270.911L168.421 268.789L170.433 267.889L171.287 270.011L169.275 270.911Z",
    fill: "#BFBFBF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.094 261.917L161.24 259.795L163.251 258.895L164.105 261.017L162.094 261.917Z",
    fill: "#BFBFBF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.482 265.365L162.628 263.244L164.64 262.343L165.494 264.465L163.482 265.365Z",
    fill: "#BFBFBF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.869 268.814L164.015 266.692L166.027 265.791L166.881 267.913L164.869 268.814Z",
    fill: "#BFBFBF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.256 272.262L165.402 270.141L167.413 269.24L168.267 271.362L166.256 272.262Z",
    fill: "#BFBFBF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.076 263.268L158.222 261.146L160.234 260.246L161.088 262.368L159.076 263.268Z",
    fill: "#BFBFBF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.463 266.717L159.609 264.595L161.62 263.694L162.474 265.816L160.463 266.717Z",
    fill: "#BFBFBF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.851 270.165L160.997 268.043L163.009 267.142L163.863 269.264L161.851 270.165Z",
    fill: "#BFBFBF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.24 273.613L162.386 271.491L164.398 270.591L165.252 272.713L163.24 273.613Z",
    fill: "#BFBFBF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.057 264.619L155.202 262.497L157.214 261.597L158.068 263.718L156.057 264.619Z",
    fill: "#BFBFBF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.445 268.067L156.591 265.945L158.603 265.045L159.457 267.167L157.445 268.067Z",
    fill: "#BFBFBF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.834 271.516L157.98 269.394L159.991 268.493L160.846 270.615L158.834 271.516Z",
    fill: "#BFBFBF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.221 274.964L159.367 272.842L161.378 271.942L162.232 274.064L160.221 274.964Z",
    fill: "#BFBFBF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.041 265.97L152.187 263.848L154.199 262.948L155.053 265.069L153.041 265.97Z",
    fill: "#BFBFBF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.428 269.418L153.574 267.296L155.585 266.396L156.439 268.518L154.428 269.418Z",
    fill: "#BFBFBF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.814 272.866L154.96 270.745L156.972 269.844L157.826 271.966L155.814 272.866Z",
    fill: "#BFBFBF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.203 276.315L156.349 274.193L158.361 273.292L159.215 275.414L157.203 276.315Z",
    fill: "#BFBFBF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.381 278.626L171.527 276.504L173.538 275.603L174.392 277.725L172.381 278.626Z",
    fill: "#BFBFBF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.767 282.074L172.913 279.952L174.925 279.052L175.779 281.173L173.767 282.074Z",
    fill: "#BFBFBF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.156 285.523L174.302 283.401L176.314 282.5L177.168 284.622L175.156 285.523Z",
    fill: "#BFBFBF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.545 288.971L175.691 286.849L177.702 285.949L178.556 288.07L176.545 288.971Z",
    fill: "#BFBFBF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.361 279.977L168.507 277.855L170.519 276.954L171.373 279.076L169.361 279.977Z",
    fill: "#BFBFBF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.75 283.425L169.896 281.303L171.907 280.403L172.762 282.525L170.75 283.425Z",
    fill: "#BFBFBF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.139 286.873L171.284 284.751L173.296 283.851L174.15 285.973L172.139 286.873Z",
    fill: "#BFBFBF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.525 290.322L172.671 288.2L174.683 287.299L175.537 289.421L173.525 290.322Z",
    fill: "#BFBFBF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.346 281.327L165.492 279.206L167.503 278.305L168.357 280.427L166.346 281.327Z",
    fill: "#BFBFBF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.732 284.776L166.878 282.654L168.89 281.753L169.744 283.875L167.732 284.776Z",
    fill: "#BFBFBF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.119 288.224L168.265 286.102L170.277 285.202L171.131 287.324L169.119 288.224Z",
    fill: "#BFBFBF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.508 291.673L169.654 289.551L171.665 288.65L172.519 290.772L170.508 291.673Z",
    fill: "#BFBFBF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.326 282.678L162.472 280.557L164.484 279.656L165.338 281.778L163.326 282.678Z",
    fill: "#BFBFBF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.715 286.127L163.861 284.005L165.872 283.104L166.726 285.226L164.715 286.127Z",
    fill: "#BFBFBF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.103 289.575L165.249 287.453L167.261 286.553L168.115 288.674L166.103 289.575Z",
    fill: "#BFBFBF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.49 293.023L166.636 290.901L168.648 290.001L169.502 292.123L167.49 293.023Z",
    fill: "#BFBFBF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.308 284.029L159.454 281.907L161.466 281.007L162.32 283.129L160.308 284.029Z",
    fill: "#BFBFBF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.697 287.478L160.843 285.356L162.855 284.455L163.709 286.577L161.697 287.478Z",
    fill: "#BFBFBF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.084 290.926L162.23 288.804L164.241 287.904L165.096 290.026L163.084 290.926Z",
    fill: "#BFBFBF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.473 294.374L163.618 292.252L165.63 291.352L166.484 293.474L164.473 294.374Z",
    fill: "#BFBFBF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.65 296.685L178.796 294.563L180.808 293.663L181.662 295.785L179.65 296.685Z",
    fill: "#BFBFBF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.037 300.134L180.183 298.012L182.195 297.111L183.049 299.233L181.037 300.134Z",
    fill: "#BFBFBF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.426 303.582L181.572 301.46L183.583 300.559L184.437 302.681L182.426 303.582Z",
    fill: "#BFBFBF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.812 307.03L182.958 304.908L184.97 304.008L185.824 306.129L183.812 307.03Z",
    fill: "#BFBFBF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.631 298.036L175.777 295.914L177.788 295.014L178.642 297.135L176.631 298.036Z",
    fill: "#BFBFBF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.019 301.484L177.165 299.362L179.177 298.462L180.031 300.584L178.019 301.484Z",
    fill: "#BFBFBF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.408 304.933L178.554 302.811L180.566 301.91L181.42 304.032L179.408 304.933Z",
    fill: "#BFBFBF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.795 308.381L179.941 306.259L181.952 305.359L182.806 307.481L180.795 308.381Z",
    fill: "#BFBFBF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.613 299.387L172.759 297.265L174.771 296.365L175.625 298.486L173.613 299.387Z",
    fill: "#BFBFBF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.002 302.835L174.148 300.713L176.159 299.813L177.014 301.935L175.002 302.835Z",
    fill: "#BFBFBF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.389 306.283L175.534 304.162L177.546 303.261L178.4 305.383L176.389 306.283Z",
    fill: "#BFBFBF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.777 309.732L176.923 307.61L178.935 306.709L179.789 308.831L177.777 309.732Z",
    fill: "#BFBFBF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.596 300.738L169.742 298.616L171.753 297.715L172.607 299.837L170.596 300.738Z",
    fill: "#BFBFBF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.984 304.186L171.13 302.064L173.142 301.163L173.996 303.285L171.984 304.186Z",
    fill: "#BFBFBF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.371 307.634L172.517 305.513L174.529 304.612L175.383 306.734L173.371 307.634Z",
    fill: "#BFBFBF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.76 311.083L173.906 308.961L175.917 308.06L176.771 310.182L174.76 311.083Z",
    fill: "#BFBFBF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.578 302.089L166.724 299.967L168.736 299.066L169.59 301.188L167.578 302.089Z",
    fill: "#BFBFBF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.967 305.537L168.113 303.415L170.124 302.514L170.978 304.636L168.967 305.537Z",
    fill: "#BFBFBF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.353 308.985L169.499 306.863L171.511 305.963L172.365 308.085L170.353 308.985Z",
    fill: "#BFBFBF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.742 312.433L170.888 310.311L172.9 309.411L173.754 311.533L171.742 312.433Z",
    fill: "#BFBFBF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.681 209.889L135.425 201.798L133.702 202.57L136.958 210.66L138.681 209.889Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.364 214.193L140.807 212.652L139.23 208.734L135.787 210.275L137.364 214.193Z",
    fill: "#BFBFBF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.364 214.193L140.807 212.652L139.23 208.734L135.787 210.275L137.364 214.193Z",
    fill: "white",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.185 193.671L139.039 195.793L141.051 194.892L140.197 192.77L138.185 193.671Z",
    fill: "#BFBFBF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.796 190.223L137.65 192.344L139.662 191.444L138.808 189.322L136.796 190.223Z",
    fill: "#BFBFBF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.409 186.774L136.264 188.896L138.275 187.996L137.421 185.874L135.409 186.774Z",
    fill: "#BFBFBF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.021 183.326L134.875 185.448L136.887 184.547L136.032 182.426L134.021 183.326Z",
    fill: "#BFBFBF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.167 195.022L136.021 197.144L138.033 196.243L137.179 194.121L135.167 195.022Z",
    fill: "#BFBFBF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.779 191.574L134.633 193.696L136.644 192.795L135.79 190.673L133.779 191.574Z",
    fill: "#BFBFBF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.39 188.125L133.244 190.247L135.256 189.347L134.402 187.225L132.39 188.125Z",
    fill: "#BFBFBF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.003 184.677L131.857 186.799L133.869 185.899L133.015 183.777L131.003 184.677Z",
    fill: "#BFBFBF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.15 196.373L133.004 198.495L135.015 197.594L134.161 195.472L132.15 196.373Z",
    fill: "#BFBFBF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.761 192.924L131.615 195.046L133.627 194.146L132.773 192.024L130.761 192.924Z",
    fill: "#BFBFBF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.372 189.476L130.226 191.598L132.238 190.697L131.384 188.576L129.372 189.476Z",
    fill: "#BFBFBF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.986 186.028L128.84 188.15L130.851 187.249L129.997 185.127L127.986 186.028Z",
    fill: "#BFBFBF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.132 197.724L129.986 199.845L131.998 198.945L131.144 196.823L129.132 197.724Z",
    fill: "#BFBFBF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.743 194.275L128.598 196.397L130.609 195.497L129.755 193.375L127.743 194.275Z",
    fill: "#BFBFBF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.355 190.827L127.209 192.949L129.221 192.048L128.366 189.927L126.355 190.827Z",
    fill: "#BFBFBF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.968 187.379L125.822 189.501L127.834 188.6L126.98 186.478L124.968 187.379Z",
    fill: "#BFBFBF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.113 199.075L126.967 201.197L128.978 200.296L128.124 198.174L126.113 199.075Z",
    fill: "#BFBFBF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.726 195.626L125.58 197.748L127.592 196.847L126.738 194.725L124.726 195.626Z",
    fill: "#BFBFBF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.337 192.178L124.191 194.3L126.203 193.399L125.349 191.277L123.337 192.178Z",
    fill: "#BFBFBF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.949 188.729L122.803 190.851L124.814 189.951L123.96 187.829L121.949 188.729Z",
    fill: "#BFBFBF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.915 175.612L131.769 177.734L133.781 176.833L132.927 174.711L130.915 175.612Z",
    fill: "#BFBFBF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.527 172.164L130.381 174.285L132.392 173.385L131.538 171.263L129.527 172.164Z",
    fill: "#BFBFBF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.14 168.715L128.994 170.837L131.006 169.937L130.152 167.815L128.14 168.715Z",
    fill: "#BFBFBF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.751 165.267L127.605 167.389L129.617 166.488L128.763 164.367L126.751 165.267Z",
    fill: "#BFBFBF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.898 176.962L128.752 179.084L130.764 178.184L129.909 176.062L127.898 176.962Z",
    fill: "#BFBFBF"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.509 173.514L127.363 175.636L129.375 174.735L128.521 172.614L126.509 173.514Z",
    fill: "#BFBFBF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.12 170.066L125.974 172.188L127.986 171.287L127.132 169.165L125.12 170.066Z",
    fill: "#BFBFBF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.734 166.618L124.588 168.739L126.599 167.839L125.745 165.717L123.734 166.618Z",
    fill: "#BFBFBF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.88 178.313L125.734 180.435L127.746 179.535L126.892 177.413L124.88 178.313Z",
    fill: "#BFBFBF"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.492 174.865L124.346 176.987L126.357 176.087L125.503 173.965L123.492 174.865Z",
    fill: "#BFBFBF"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.105 171.417L122.959 173.539L124.971 172.638L124.116 170.516L122.105 171.417Z",
    fill: "#BFBFBF"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.716 167.969L121.57 170.091L123.582 169.19L122.728 167.068L120.716 167.969Z",
    fill: "#BFBFBF"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.863 179.664L122.717 181.786L124.728 180.886L123.874 178.764L121.863 179.664Z",
    fill: "#BFBFBF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.474 176.216L121.328 178.338L123.34 177.437L122.486 175.315L120.474 176.216Z",
    fill: "#BFBFBF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.085 172.768L119.939 174.889L121.951 173.989L121.097 171.867L119.085 172.768Z",
    fill: "#BFBFBF"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.699 169.319L118.553 171.441L120.564 170.541L119.71 168.419L117.699 169.319Z",
    fill: "#BFBFBF"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.845 181.015L119.699 183.137L121.711 182.236L120.857 180.115L118.845 181.015Z",
    fill: "#BFBFBF"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.456 177.567L118.31 179.689L120.322 178.788L119.468 176.666L117.456 177.567Z",
    fill: "#BFBFBF"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.068 174.119L116.922 176.24L118.933 175.34L118.079 173.218L116.068 174.119Z",
    fill: "#BFBFBF"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.679 170.67L115.533 172.792L117.545 171.892L116.691 169.77L114.679 170.67Z",
    fill: "#BFBFBF"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.646 157.552L124.5 159.674L126.512 158.774L125.657 156.652L123.646 157.552Z",
    fill: "#BFBFBF"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.257 154.104L123.111 156.226L125.123 155.325L124.269 153.203L122.257 154.104Z",
    fill: "#BFBFBF"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.87 150.656L121.724 152.778L123.736 151.877L122.882 149.755L120.87 150.656Z",
    fill: "#BFBFBF"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.482 147.207L120.336 149.329L122.348 148.429L121.493 146.307L119.482 147.207Z",
    fill: "#BFBFBF"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.336 149.329L122.348 148.429L121.493 146.307L119.482 147.207L120.336 149.329Z",
    fill: "#BFBFBF"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.628 158.903L121.482 161.025L123.494 160.125L122.64 158.003L120.628 158.903Z",
    fill: "#BFBFBF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.24 155.455L120.094 157.577L122.105 156.676L121.251 154.555L119.24 155.455Z",
    fill: "#BFBFBF"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.853 152.007L118.707 154.129L120.719 153.228L119.865 151.106L117.853 152.007Z",
    fill: "#BFBFBF"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.464 148.559L117.318 150.68L119.33 149.78L118.476 147.658L116.464 148.559Z",
    fill: "#BFBFBF"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.611 160.254L118.465 162.376L120.476 161.475L119.622 159.353L117.611 160.254Z",
    fill: "#BFBFBF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.222 156.806L117.076 158.927L119.088 158.027L118.234 155.905L116.222 156.806Z",
    fill: "#BFBFBF"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.835 153.357L115.689 155.479L117.701 154.579L116.847 152.457L114.835 153.357Z",
    fill: "#BFBFBF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.447 149.909L114.301 152.031L116.312 151.13L115.458 149.009L113.447 149.909Z",
    fill: "#BFBFBF"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.593 161.605L115.447 163.727L117.459 162.826L116.605 160.704L114.593 161.605Z",
    fill: "#BFBFBF"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.204 158.157L114.058 160.279L116.07 159.378L115.216 157.256L113.204 158.157Z",
    fill: "#BFBFBF"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.816 154.708L112.67 156.83L114.681 155.93L113.827 153.808L111.816 154.708Z",
    fill: "#BFBFBF"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.429 151.26L111.283 153.382L113.295 152.482L112.441 150.36L110.429 151.26Z",
    fill: "#BFBFBF"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.575 162.956L112.43 165.078L114.441 164.177L113.587 162.056L111.575 162.956Z",
    fill: "#BFBFBF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.187 159.508L111.041 161.63L113.053 160.729L112.199 158.607L110.187 159.508Z",
    fill: "#BFBFBF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.8 156.059L109.654 158.181L111.666 157.28L110.812 155.159L108.8 156.059Z",
    fill: "#BFBFBF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.411 152.611L108.266 154.733L110.277 153.832L109.423 151.71L107.411 152.611Z",
    fill: "#BFBFBF"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.323 199.933C209.768 196.07 209.134 192.658 209.906 192.312C210.679 191.966 212.565 194.818 214.121 198.68C215.675 202.544 216.31 205.955 215.537 206.301C214.764 206.647 212.878 203.796 211.323 199.933Z",
    fill: "#F5F5F5"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.323 199.933C209.768 196.07 209.134 192.658 209.906 192.312C210.679 191.966 212.565 194.818 214.121 198.68C215.675 202.544 216.31 205.955 215.537 206.301C214.764 206.647 212.878 203.796 211.323 199.933Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.471 197.18C214.365 189.462 213.097 182.644 214.641 181.953C216.184 181.263 219.954 186.96 223.06 194.678C226.168 202.397 227.435 209.214 225.892 209.905C224.348 210.596 220.579 204.899 217.471 197.18Z",
    fill: "#F5F5F5"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.471 197.18C214.365 189.462 213.097 182.644 214.641 181.953C216.184 181.263 219.954 186.96 223.06 194.678C226.168 202.397 227.435 209.214 225.892 209.905C224.348 210.596 220.579 204.899 217.471 197.18Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.401 192.736C223.237 182.392 221.538 173.256 223.607 172.33C225.676 171.404 230.727 179.039 234.891 189.383C239.055 199.727 240.753 208.863 238.685 209.789C236.616 210.715 231.564 203.08 227.401 192.736Z",
    fill: "#F5F5F5"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.401 192.736C223.237 182.392 221.538 173.256 223.607 172.33C225.676 171.404 230.727 179.039 234.891 189.383C239.055 199.727 240.753 208.863 238.685 209.789C236.616 210.715 231.564 203.08 227.401 192.736Z",
    stroke: "#A3B1BF",
    strokeWidth: 1.62,
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.878 99.1907C147.453 98.0422 145.844 96.6759 146.115 95.8898C146.386 95.1045 148.447 95.1477 151.001 95.91C152.083 93.3526 153.355 91.6504 154.074 91.9265C154.793 92.2025 154.73 94.369 154.001 97.0617C156.422 98.2094 158.027 99.5737 157.756 100.359C157.484 101.145 155.419 101.101 152.862 100.336C151.79 102.83 150.545 104.477 149.837 104.205C149.129 103.933 149.179 101.827 149.878 99.1907Z",
    fill: "#BFBFBF"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.57 340.839L201.235 341.228C200.372 342.229 198.902 342.303 197.953 341.393C197.575 341.03 197.32 340.546 197.229 340.016L197.141 339.5L196.688 339.284C195.518 338.728 194.997 337.277 195.524 336.043C195.734 335.551 196.092 335.146 196.542 334.891L196.98 334.642L197.035 334.12C197.175 332.774 198.323 331.804 199.598 331.951C200.106 332.01 200.581 332.244 200.95 332.617L201.311 332.98L201.798 332.873C203.054 332.598 204.284 333.449 204.545 334.775C204.649 335.302 204.585 335.852 204.363 336.337L204.147 336.81L204.394 337.265C205.03 338.441 204.643 339.938 203.529 340.609C203.085 340.876 202.57 340.982 202.064 340.91L201.57 340.839Z",
    fill: "#BFBFBF"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.99 129.896L501.99 129.896C501.298 130.329 500.405 130.09 499.994 129.36C499.83 129.07 499.762 128.731 499.799 128.395C499.195 127.836 499.135 126.865 499.665 126.227C499.876 125.974 500.161 125.8 500.475 125.734L500.475 125.734C500.793 124.954 501.65 124.594 502.389 124.93C502.683 125.063 502.928 125.295 503.084 125.59L503.084 125.59C503.885 125.668 504.475 126.416 504.401 127.26C504.372 127.597 504.238 127.914 504.02 128.162C504.198 128.989 503.705 129.812 502.921 129.999C502.608 130.073 502.281 130.037 501.991 129.896L501.99 129.896Z",
    fill: "#BFBFBF"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.953 47.7008L181.157 47.8298C179.888 48.0352 178.702 47.1171 178.507 45.7791C178.43 45.2464 178.521 44.7015 178.767 44.2289L179.154 43.4842L178.792 42.7263C178.214 41.5174 178.675 40.0437 179.821 39.4347C180.278 39.1921 180.797 39.1151 181.3 39.2155L182.091 39.3737L182.663 38.7753C183.575 37.8227 185.046 37.8301 185.949 38.7918C186.309 39.1747 186.539 39.6718 186.603 40.2064L186.705 41.0498L187.421 41.4388C188.562 42.059 189.01 43.5371 188.422 44.7403C188.188 45.2195 187.81 45.604 187.348 45.834L186.62 46.1962L186.491 47.0344C186.284 48.3704 185.09 49.2767 183.823 49.0588C183.319 48.972 182.856 48.7123 182.506 48.3198L181.953 47.7008Z",
    fill: "#BFBFBF"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M467.249 317.24L466.739 317.104C465.496 316.77 464.744 315.436 465.061 314.124C465.187 313.602 465.472 313.138 465.873 312.804L466.286 312.461L466.251 311.909C466.168 310.558 467.138 309.392 468.418 309.304C468.928 309.268 469.435 309.412 469.86 309.711L470.297 310.019L470.785 309.813C471.977 309.312 473.329 309.925 473.804 311.183C473.993 311.683 474.02 312.236 473.882 312.754L473.739 313.288L474.075 313.714C474.895 314.755 474.76 316.3 473.773 317.166C473.38 317.51 472.891 317.709 472.38 317.73L471.856 317.752L471.576 318.22C470.891 319.365 469.456 319.707 468.37 318.984C467.938 318.696 467.608 318.266 467.431 317.761L467.249 317.24Z",
    fill: "#BFBFBF"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.967 156.416L508.966 156.416C508.348 156.958 507.43 156.869 506.916 156.216C506.711 155.957 506.593 155.633 506.58 155.295C505.9 154.842 505.697 153.894 506.126 153.176C506.297 152.891 506.553 152.672 506.853 152.555L506.854 152.555C507.052 151.733 507.845 151.236 508.624 151.445C508.935 151.528 509.21 151.717 509.409 151.982L509.409 151.982C510.212 151.927 510.905 152.569 510.957 153.415C510.978 153.752 510.893 154.087 510.715 154.368C511.013 155.156 510.649 156.05 509.901 156.364C509.604 156.489 509.276 156.507 508.967 156.416L508.967 156.416Z",
    fill: "#BFBFBF"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.901 231.376C353.012 231.376 378.233 204.777 378.233 171.966C378.233 139.154 353.012 112.556 321.901 112.556C290.789 112.556 265.568 139.154 265.568 171.966C265.568 204.777 290.789 231.376 321.901 231.376Z",
    fill: "#BFBFBF"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.592 151.136C318.577 151.136 315.454 152.43 313.224 155.016C310.993 157.485 309.934 160.778 309.934 164.893H314.339C314.339 162.012 314.952 159.778 316.179 158.132C317.518 156.192 319.581 155.251 322.369 155.251C324.711 155.251 326.551 155.898 327.834 157.309C329.061 158.602 329.73 160.425 329.73 162.776C329.73 164.422 329.172 165.951 328.057 167.421C327.722 167.891 327.053 168.596 326.161 169.537C323.15 172.359 321.309 174.593 320.529 176.356C319.86 177.826 319.525 179.531 319.525 181.471V182.823H323.986V181.471C323.986 179.884 324.321 178.473 325.046 177.18C325.603 176.121 326.44 175.063 327.667 173.946C330.12 171.653 331.626 170.125 332.183 169.419C333.578 167.479 334.302 165.187 334.302 162.541C334.302 159.014 333.243 156.251 331.18 154.252C329.005 152.136 326.161 151.136 322.592 151.136ZM321.756 186.938C320.808 186.938 320.027 187.232 319.358 187.938C318.689 188.584 318.41 189.408 318.41 190.407C318.41 191.406 318.689 192.229 319.358 192.935C320.027 193.581 320.808 193.934 321.756 193.934C322.704 193.934 323.484 193.581 324.153 192.935C324.823 192.288 325.157 191.465 325.157 190.407C325.157 189.408 324.823 188.584 324.209 187.938C323.54 187.232 322.704 186.938 321.756 186.938Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.478 143.148C307.038 139.762 317.13 135.773 313.92 129.908C310.709 124.044 298.9 124.895 293.339 128.281C287.778 131.667 281.846 141.618 285.056 147.483C288.267 153.348 295.917 146.533 301.478 143.148Z",
    fill: "#FAFAFA"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.736 129.714C329.305 129.714 331.387 127.518 331.387 124.809C331.387 122.1 329.305 119.904 326.736 119.904C324.168 119.904 322.086 122.1 322.086 124.809C322.086 127.518 324.168 129.714 326.736 129.714Z",
    fill: "#FAFAFA"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M491.027 333.132L492.462 334.645",
    stroke: "#979797",
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.f480d0bfb2f3bd50218b641ff0324a5d.svg";
export { ForwardRef as ReactComponent };